import { Grid } from '@mui/material';
import Utils from '../../../utils/Utils';
import BlockProps from '../../../models/BlockProps';
import BlockButtonData from './BlockButtonData';
import LinkButton from '../../Buttons/LinkButton';
import BlockData from '../../../models/BlockData';
import BlockComponentButton from '../../../models/BlockComponentValues/BlockComponentButton';

export interface BlockButtonProps extends BlockProps {
  blockData: BlockData[]
}

function BlockButton({
  data, isEditing, isTemplate, editHandler, blockData,
}: BlockButtonProps) {
  const props = (data.data as BlockButtonData);
  const handleUpdate = (button?: BlockComponentButton) => {
    props.button = button;
    editHandler(data.id, props);
  };

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{
        minHeight: '100px',
        padding: 1.5,
        overflow: 'hidden',
      }}
    >

      <Grid
        item
        sx={[Utils.hoverBorder(isEditing), {
          maxWidth: '100%',
          maxHeight: '100%',
          height: '100%',
          width: '100%',
        }]}
      >

        <LinkButton
          button={props.button}
          isEditable={isEditing && !isTemplate}
          isTemplate={isTemplate}
          updateHandler={handleUpdate}
          blockData={blockData}
        />

      </Grid>

    </Grid>
  );
}

export default BlockButton;
